import styled from 'styled-components';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

const StyledSelect = styled(Select)`
  font-family: ${props => props.theme.fontFamily};
  color: ${props => props.theme.colors.black};
  background: ${props => props.theme.colors.white};
  border: 0.0625em solid ${props => props.theme.colors.black};
  height: 2em;
  width: ${props => props.theme.fullWidth};
  border-radius: 0;
  &.Select.is-focused {
    box-shadow: ${props => props.theme.forms.input.focusOutline};
  }

  &.select-multi {
    height: inherit;
    .Select-input {
      min-height: 2em;
      height: inherit;
      .Select-control {
        min-height: 2em;
      }
    }
  }

  &.openUp {
    .Select-menu-outer {
      top: auto;
      bottom: 100%;
      border-radius: 0;
      z-index: 100;
    }
  }

  &.noBorder {
    border: none;
  }

  &.Select.is-disabled > .Select-control,
  &.Select.is-focused > .Select-control {
    background: transparent;
  }

  &.Select.is-disabled {
    background-color: ${props =>
      props.theme.forms.input.disabledBackgroundColor};
  }

  .Select-menu {
    max-height: 160px;
  }

  .Select-control {
    background: transparent;
    border: 0;
    height: 2em;

    .Select-input {
      height: 2em;
    }

    .Select-multi-value-wrapper {
      .Select-value,
      .Select-placeholder {
        line-height: 2em;
      }

      .Select-value {
        height: 2em;
      }
    }

    & > *:last-child {
      padding-right: 0.3em;
    }

    .Select-arrow-zone {
      width: 1.5em;
      line-height: 2em;
    }

    .Select-clear-zone {
      color: ${props => props.theme.colors.disabledButtonText};
    }
  }

  &.select-multi {
    .Select-control .Select-multi-value-wrapper .Select-value {
      height: 1.8em;
      line-height: 1.5em;
      margin-top: 0.2em;
      margin-left: 0.2em;
    }
  }
`;

export default StyledSelect;
